module.exports = "# 快速开始\n## 安装\n#### 安装环境\n所必需的环境 node.js、npm\n#### 安装步骤\n```\n# 克隆远程仓库框架\ngit clone https://github.com/changlor/rain.git\n# cd到项目\ncd rain/\n# 切断与原项目的联系\nrm -rf .git\n# 安装包依赖\nnpm install # 此方法由于安装速度过慢，有时会出错\n# 推荐使用cnpm\ncnpm install\n# cnpm安装方法\nnpm install -g cnpm --registry=https://registry.npm.taobao.org\n# 本地开启http服务\nnpm run dev\n```\n"


//////////////////
// WEBPACK FOOTER
// ./src/store/quickStart.md
// module id = 154
// module chunks = 2